// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1979":"7c95a7c6","4881":"7c95a7c6","6595":"7c95a7c6"}[chunkId] + ".chunk.css";
};